import Enumerator from '../global/Enumerator';
import { HouseholdExpenseType } from './HouseholdExpense.enum';

export const householdCategories = ['hem', 'other'];

export class HouseholdCategory extends Enumerator {
  static default() {
    return this.of('hem');
  }
}

HouseholdCategory.initEnum({
  hem: {
    get title() {
      return 'HEM';
    },
    get types() {
      return [
        HouseholdExpenseType.food_and_supermarket.name,
        HouseholdExpenseType.coffees_lunches_takeaway.name,
        HouseholdExpenseType.entertainment.name,
        HouseholdExpenseType.domestic_holidays.name,
        HouseholdExpenseType.gym_fees_sport_other_health_and_wellness.name,
        HouseholdExpenseType.cigarettes_and_alcohol.name,
        HouseholdExpenseType.clothing_shoes_and_accessories.name,
        HouseholdExpenseType.hairdressing_and_grooming.name,
        HouseholdExpenseType.phone_internet_and_pay_tv.name,
        HouseholdExpenseType.media_streaming_and_subscription_services.name,
        HouseholdExpenseType.pets.name,
        HouseholdExpenseType.public_education_costs.name,
        HouseholdExpenseType.tertiary_and_vocational_education.name,
        HouseholdExpenseType.childcare.name,
        HouseholdExpenseType.doctor_dentist_pharmacy_glasses.name,
        HouseholdExpenseType.essential_vehicle_running_cost.name,
        HouseholdExpenseType.public_transport_taxis_and_ride_share_commuting_airfares.name,
        HouseholdExpenseType.essential_vehicle_insurance.name,
        HouseholdExpenseType.primary_residence_running_costs.name
      ];
    }
  },
  other: {
    get title() {
      return 'Other';
    },
    get types() {
      return [
        HouseholdExpenseType.gifts_and_celebrations.name,
        HouseholdExpenseType.other_discretionary_expenses.name,
        HouseholdExpenseType.recreational_vehicle_running_costs.name,
        HouseholdExpenseType.private_education_costs.name,
        HouseholdExpenseType.child_or_spousal_maintenance.name,
        HouseholdExpenseType.private_health_insurance.name,
        HouseholdExpenseType.life_trauma_income_insurance.name,
        HouseholdExpenseType.current_rent_expense.name,
        HouseholdExpenseType.ongoing_board_expense.name,
        HouseholdExpenseType.primary_residence_body_corp.name,
        HouseholdExpenseType.secondary_residence_running_costs.name,
        HouseholdExpenseType.secondary_residence_body_corp.name,
        HouseholdExpenseType.investment_property_running_costs.name,
        HouseholdExpenseType.investment_property_body_corp.name
      ];
    }
  }
});

export default {
  householdCategories,
  HouseholdCategory
};
